import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'
import { DrivenDistancePerYear as DrivenDistancePerYearEnum } from 'containers/OpportunityCarInsurance/types'

import { ButtonLink, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { Header } from 'components/Layout'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.DrivenDistancePerYear> & {
	onShowCurrentCoverage: Handlers['onShowCurrentCoverage']

	onStepBack?: () => void
}

const topics = [
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.drivenDistancePerYear.labelLessThan7500km'
				defaultMessage='Less than 7,500km'
			/>
		),
		value: DrivenDistancePerYearEnum.LessThan7500,
	},
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.drivenDistancePerYear.labelBetween7500And15000km'
				defaultMessage='7,500km - 15,000km'
			/>
		),
		value: DrivenDistancePerYearEnum.Between7500And15000,
	},
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.drivenDistancePerYear.labelBetween15000And25000km'
				defaultMessage='15,000km - 25,000km'
			/>
		),
		value: DrivenDistancePerYearEnum.Between15000And25000,
	},
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.drivenDistancePerYear.labelMoreThan25000km'
				defaultMessage='More than 25,000km'
			/>
		),
		value: DrivenDistancePerYearEnum.MoreThan25000,
	},
]

export const DrivenDistancePerYear = ({
	selectedInsurer,
	personalDetails,
	licensePlate,
	damageFreeYears,
	onShowCurrentCoverage,
	onStepBack,
}: Props) => (
	<Card>
		<Header>
			<Title>
				<FormattedMessage
					id='opportunityCarInsurance.drivenDistancePerYear.title'
					defaultMessage='How many kilometers do you drive per year?'
				/>
			</Title>
		</Header>
		<p role='text' style={{ marginBottom: '16px' }}>
			<FormattedMessage
				id='opportunityCarInsurance.drivenDistancePerYear.description'
				defaultMessage='You can estimate the number of kilometers you expect to drive here.'
			/>
		</p>
		<div style={{ marginTop: '8px' }}>
			{topics.map(({ label, value }) => (
				<ButtonLink
					key={value}
					label={label}
					onClick={() => onShowCurrentCoverage(selectedInsurer, personalDetails, licensePlate, damageFreeYears, value)}
				/>
			))}
		</div>
		<ButtonGroup center>
			<ButtonText
				label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
				onClick={onStepBack}
			/>
		</ButtonGroup>
	</Card>
)
